module.exports = __webpack_public_path__ + "static/logo-perhutani-ffb2a7721e0ac7b328e94c4de270aa1b.png";